import 'ol/ol.css';

import ImageWMS from 'ol/source/ImageWMS';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import {Image as ImageLayer, Tile as TileLayer} from 'ol/layer';
import  {fromLonLat} from 'ol/proj';
import MousePosition from 'ol/control/MousePosition';
import {defaults as defaultControls} from 'ol/control';
import {createStringXY} from 'ol/coordinate';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';
import {Projections} from "./Projections.js";
import LayerGroup from 'ol/layer/Group';
import Overlay from 'ol/Overlay';

import 'ol-layerswitcher/src/ol-layerswitcher.css';
import {getCenter} from 'ol/extent';
import LayerSwitcher from 'ol-layerswitcher';
import ScaleLine from "ol/control/ScaleLine";
import geocoder from "ol-geocoder";
import WMSGetFeatureInfo from 'ol/format/WMSGetFeatureInfo';
import {FeatureInfoControl} from "./FeatureInfoControl";
import {LegendControl} from "./LegendControl";

require('es6-promise').polyfill();
require('isomorphic-fetch');

export class MapControl {

    layers=[];

    wmtsLayers=[
        {
            "title":"ZBGIS",
            "visible":false,
            "url":"https://zbgisws.skgeodesy.sk/zbgis_wmts_new/service.svc/get",
            "matrixSet":"default028mm",
            "layer":"WMS_zbgis_wmts_new",
            "attribution": "&#169; GKÚ Bratislava; r. 2017"
        },
        {
            "title":"Ortofoto",
            "visible":false,
            "url":"https://zbgisws.skgeodesy.sk/zbgis_ortofoto_wmts/service.svc/get",
            "matrixSet":"default028mm",
            "layer":"WMS_zbgis_ortofoto_wmts",
            "attribution": "&#169; GKÚ, NLC; r.2017 - 2019"
        }
    ];
    vusLayer;
    constructor() {
        const projections = new Projections();
        const self=this;
        this.getLayers().then(function(layers)
        {
            self.initMap(layers);
        });
    }
    getLayers() {
        var tasks=new Array();
        this.wmtsLayers.forEach(cfg=>{
            var lyr=this.loadWMTS(cfg);
            if(lyr) tasks.push(lyr);
        });
        var self=this;

        const osmLayer = new TileLayer({
            title:"OSM",
            type:"base",
            source: new OSM()
        });
        var promise=new Promise(function(resolve){
            Promise.all(tasks).then(function(values) {
                var basemaps =[osmLayer];
                values.forEach(r=> {
                    if (r && r.values_){
                         basemaps.push(r);
                    }
                });
                self.vusLayer = new ImageLayer({
                    //extent: [1727409, 6030105, 2631753, 6415844],
                    source: new ImageWMS({
                        url: 'https://iek.sk:8443/geoserver/wms',
                        params: {'LAYERS': 'vus:vrstvyemp'},
                        ratio: 1,
                        serverType: 'geoserver' ,
                        crossOrigin: 'anonymous'
                    }),
                    title:'Merania'
                });
                const lyrs=[new LayerGroup( {
                    title: "Podkladové mapy",
                    combine: false,
                    layers:basemaps}),
                     new LayerGroup( {
                    title: "Vrstvy" ,
                    combine: false,
                    layers:[self.vusLayer]})];

                resolve(lyrs);
            });
        });
        return promise;
    }


    loadWMTS(cfg) {

        const parser = new WMTSCapabilities();
        const promise=new Promise(function(resolve) {
            fetch(cfg.url).then(function (response) {
                return response.text();
            }).then(function (text) {
                var result = parser.read(text);
                var options = optionsFromCapabilities(result, {
                    layer: cfg.layer,
                    projection:"EPSG:5514",
                    matrixSet: cfg.matrixSet
                });

                options.attributions=[cfg.attribution];
                options.crossOrigin= 'Anonymous';
                var lyr=new TileLayer({
                    title: cfg.title,
                    type:"base",
                    visible: cfg.visible,
                    opacity: 1,
                    source: new WMTS((options))
                });
                resolve(lyr);

            },function(reject){
                resolve(null);
            });
        });
        return promise;
    }
    initMap(layers) {
        const mousePositionControl = new MousePosition({
            coordinateFormat: createStringXY(4),
            className: "mouse-position",
            projection: 'EPSG:4326'
        });


        this.map = new Map({
            target: 'map',
            controls: defaultControls().extend([mousePositionControl]),
            layers: layers,
            //overlays: [this.overlay],
            view: new View({
                center: fromLonLat([19.45, 48.6]),
                zoom: 8
            })
        });
        const layerSwitcher = new LayerSwitcher();

        this.map.addControl(layerSwitcher);
        this.map.addControl(new ScaleLine());


        const search = new geocoder('nominatim', {
            provider: 'osm',
            autoComplete : true,
            autoCompleteMinLength: 3,
            countrycodes : 'SK',
            targetType: 'text-input',
            lang: 'en',
            placeholder: 'Hľadať ...',
            limit: 5,
            keepOpen: false
        });

        this.map.addControl(search);
        const fInfo=new FeatureInfoControl({wmsLayer:this.vusLayer});
        this.map.addControl(fInfo);
        fInfo.activate();
        const legend=new LegendControl({wmsLayer:this.vusLayer});
        this.map.addControl(legend);
        legend.updateLegend();

    }


}